export default function getDiscountedPrice(
  price: number,
  discount?: number,
): string | number {
  if (discount) {
    return (price - (price * discount) / 100).toFixed(2);
  } else {
    return price;
  }
}
